import { RouteComponent, RouteRecordRaw } from 'vue-router';
import { psManagementRoutes } from '@/router/routes/ps-management/ps-management.routes';
import { transactionsRoutes } from '@/router/routes/transactions/transactions.routes';
import { cashierSettingsRoutes } from '@/router/routes/cashier-settings/cashier-settings.routes';
import { logsRoutes } from '@/router/routes/logs-page/logs.routes';
import { pspSortingRoutes } from '@/router/routes/psp-sorting/psp-sorting.routes';
import { currencyRoutes } from '@/router/routes/currency/currency.routes';
import { pspTagRoutes } from '@/router/routes/psp-tag/psp-tag.routes';
import { limitExceptionsUploadRoutes } from '@/router/routes/limit-exceptions-upload/limit-exceptions-upload.routes';

export const routes: RouteRecordRaw[] = [
  {
    name: 'home',
    path: '',
    component: async (): Promise<RouteComponent> => await import('@/layouts/home-page/home-page.vue'),
  },
  {
    name: 'permissions',
    path: '/permissions',
    component: async (): Promise<RouteComponent> => await import('@/layouts/permissions-page/permissions-page.vue'),
  },
  {
    path: '/:catchAll(.*)',
    redirect: { name: 'home' },
  },
  ...psManagementRoutes,
  ...transactionsRoutes,
  ...cashierSettingsRoutes,
  ...logsRoutes,
  ...pspSortingRoutes,
  ...currencyRoutes,
  ...pspTagRoutes,
  ...limitExceptionsUploadRoutes,
];
